import React from 'react';
import { useSelector } from 'react-redux';
import RowContainer from '../../common/CustomComponents/RowContainer';
import './securemessage.css';
const SecureMessage = () => {

  const tenantLayouts = useSelector(state => state.tenant.tenantLayout);
    return (
      tenantLayouts['SecureMessage'] && 
        <div className={tenantLayouts['SecureMessage'].className} id={tenantLayouts['SecureMessage'].id}>
        {tenantLayouts['SecureMessage'].sections.map((item,index) =>{
          return <RowContainer key={index} {...item} />;
        })}
        </div>
    );
};

export default SecureMessage;
